import { Role, RoleOptions } from '@dispatch/shared/types';
import React from 'react';

export const useGetRoleOptions = (roles: Role[]): RoleOptions[] => {
  return React.useMemo(() => {
    return roles?.map((role: Role) => {
      return {
        title: role?.name || '',
        value: role.id,
        data: { ...role, permissions: role.permissions },
      };
    });
  }, [roles]);
};
